import React from 'react';
import { Gift, TreePine, PartyPopper, Sparkles, Flag, Star, Egg, Flower2, Leaf as LeafIcon, Wheat, ShoppingBag, Tag, Ghost } from 'lucide-react';

export const Bat = ({ className = '' }) => (
  <svg viewBox="0 0 64 28" className={className} fill="currentColor" aria-hidden="true">
    <path d="M32 9c1.4-2.6 3-3.6 3-3.6l.4 3.2c2.4-.8 4-.3 4-.3 3.4-4.6 10-6.8 14.8-5.2-2.6 1.4-3.8 4-3.4 6.6 3.4-1.2 7.6.2 10 3-3.6-.4-6 1.2-6.8 3.8-3-2.2-7.4-2.2-9.6.4-1.6-2-5-2.6-7.6-.6-.8 2.4-2.6 4.6-4.8 5.8-2.2-1.2-4-3.4-4.8-5.8-2.6-2-6-1.4-7.6.6-2.2-2.6-6.6-2.6-9.6-.4C9.2 15.9 6.8 14.3 3.2 14.7c2.4-2.8 6.6-4.2 10-3 .4-2.6-.8-5.2-3.4-6.6 4.8-1.6 11.4.6 14.8 5.2 0 0 1.6-.5 4 .3l.4-3.2s1.6 1 3 3.6z" />
  </svg>
);

const svg = (vb, d) => ({ className = '' }) => <svg viewBox={vb} className={className} fill="currentColor" aria-hidden="true">{d}</svg>;
export const Shapes = {
  leaf: svg('0 0 24 24', <path d="M12 2l1.6 4.2 3.6-2-.8 4.4 4.4-.6-2.6 3.4 3.8 2-4.4 1.2 1.4 3.8-3.8-1.6L14 21l-2-3-2 3-1.2-4.2-3.8 1.6 1.4-3.8-4.4-1.2 3.8-2-2.6-3.4 4.4.6-.8-4.4 3.6 2z" />),
  snow: svg('0 0 24 24', <path d="M11 1h2v6.3l3.5-2 1 1.7-4.5 2.6v1.4h1.4L19 8.5l1.7 1-2 3.5H22v2h-3.3l2 3.5-1.7 1-2.6-4.5H13v1.4l4.5 2.6-1 1.7-3.5-2V23h-2v-6.3l-3.5 2-1-1.7 4.5-2.6V13H9.6L7 17.5l-1.7-1 2-3.5H2v-2h5.3l-2-3.5 1.7-1L9.6 11H11V9.6L6.5 7l1-1.7 3.5 2z" />),
  dot: svg('0 0 10 10', <circle cx="5" cy="5" r="5" />),
  confetti: svg('0 0 10 4', <rect width="10" height="4" rx="1" />),
  star: svg('0 0 24 24', <path d="M12 2l2.9 6.6 7.1.6-5.4 4.7 1.6 7.1L12 17.3 5.8 21l1.6-7.1L2 9.2l7.1-.6z" />),
  petal: svg('0 0 10 16', <ellipse cx="5" cy="8" rx="5" ry="8" />),
  bat: Bat,
};

const Pumpkin = () => (
  <svg viewBox="0 0 120 110" className="w-full h-full" aria-hidden="true">
    <path d="M58 22c0-9 4-15 12-18l3 5c-6 2-8 7-8 13z" fill="#4d7c0f" />
    <ellipse cx="60" cy="66" rx="52" ry="40" fill="#f97316" />
    <ellipse cx="38" cy="66" rx="20" ry="38" fill="#ea580c" opacity=".55" />
    <ellipse cx="82" cy="66" rx="20" ry="38" fill="#ea580c" opacity=".55" />
    <ellipse cx="60" cy="66" rx="14" ry="40" fill="#fb923c" opacity=".6" />
    <path d="M34 56l12-9 6 12zM86 56l-12-9-6 12z" fill="#1c0f05" />
    <path d="M32 78c10 10 46 10 56 0l-6 12-8-5-6 7-8-6-8 6-6-7-8 5z" fill="#1c0f05" />
  </svg>
);

const IconDecor = ({ main: Main, side: Side, color, glow }) => (
  <div className="relative w-full h-full grid place-items-center" style={{ color, filter: `drop-shadow(0 0 36px ${glow})` }}>
    <Main className="w-32 h-32" strokeWidth={1.3} />
    {Side && <Side className="absolute -top-1 right-0 w-10 h-10 opacity-80" strokeWidth={1.5} />}
  </div>
);

export const THEMES = {
  halloween: {
    label: 'Halloween', mode: 'dark', icon: Ghost, swatch: ['#f97316', '#581c87'],
    bg: '#140b1f', glow: 'radial-gradient(circle at 80% 40%, rgba(249,115,22,.35), transparent 55%), radial-gradient(circle at 10% 90%, rgba(124,58,237,.35), transparent 50%)',
    accent: '#fb923c', decor: <Pumpkin />, moon: true,
    particles: [{ shape: 'bat', fly: true, colors: [] }, { shape: 'leaf', colors: ['#f97316', '#ea580c', '#b45309', '#7c3aed'] }],
  },
  christmas: {
    label: 'Christmas', mode: 'light', icon: TreePine, swatch: ['#dc2626', '#166534'],
    bg: '#0b2316', glow: 'radial-gradient(circle at 80% 40%, rgba(220,38,38,.35), transparent 55%), radial-gradient(circle at 10% 90%, rgba(250,204,21,.18), transparent 50%)',
    accent: '#fca5a5', decor: <IconDecor main={TreePine} side={Gift} color="#4ade80" glow="rgba(74,222,128,.45)" />,
    particles: [{ shape: 'snow', colors: ['#ffffff', '#e0f2fe', '#f1f5f9'], dark: true }, { shape: 'dot', colors: ['#ffffff', '#e2e8f0'], dark: true }],
  },
  new_year: {
    label: 'New Year', icon: PartyPopper, swatch: ['#eab308', '#1e1b4b'],
    bg: '#0b1026', glow: 'radial-gradient(circle at 80% 40%, rgba(234,179,8,.32), transparent 55%), radial-gradient(circle at 10% 90%, rgba(99,102,241,.3), transparent 50%)',
    accent: '#fde047', decor: <IconDecor main={PartyPopper} side={Sparkles} color="#facc15" glow="rgba(250,204,21,.45)" />,
    particles: [{ shape: 'confetti', colors: ['#facc15', '#e5e7eb', '#a78bfa', '#f472b6', '#38bdf8'] }, { shape: 'star', colors: ['#fde047', '#fef3c7'] }],
  },
  july_4: {
    label: '4th of July', icon: Flag, swatch: ['#1d4ed8', '#dc2626'],
    bg: '#0a1633', glow: 'radial-gradient(circle at 80% 40%, rgba(220,38,38,.35), transparent 55%), radial-gradient(circle at 10% 90%, rgba(59,130,246,.35), transparent 50%)',
    accent: '#93c5fd', decor: <IconDecor main={Flag} side={Star} color="#f87171" glow="rgba(248,113,113,.45)" />,
    particles: [{ shape: 'star', colors: ['#dc2626', '#2563eb', '#e5e7eb'] }, { shape: 'confetti', colors: ['#dc2626', '#2563eb', '#ffffff'] }],
  },
  easter: {
    label: 'Easter', icon: Egg, swatch: ['#db2777', '#fde68a'],
    bg: '#2a1533', glow: 'radial-gradient(circle at 80% 40%, rgba(244,114,182,.35), transparent 55%), radial-gradient(circle at 10% 90%, rgba(253,230,138,.3), transparent 50%)',
    accent: '#f9a8d4', decor: <IconDecor main={Egg} side={Flower2} color="#f9a8d4" glow="rgba(249,168,212,.45)" />,
    particles: [{ shape: 'petal', colors: ['#f9a8d4', '#fde68a', '#c4b5fd', '#a7f3d0'] }],
  },
  thanksgiving: {
    label: 'Thanksgiving', icon: Wheat, swatch: ['#c2410c', '#78350f'],
    bg: '#24140a', glow: 'radial-gradient(circle at 80% 40%, rgba(234,88,12,.35), transparent 55%), radial-gradient(circle at 10% 90%, rgba(202,138,4,.3), transparent 50%)',
    accent: '#fdba74', decor: <IconDecor main={Wheat} side={LeafIcon} color="#fbbf24" glow="rgba(251,191,36,.4)" />,
    particles: [{ shape: 'leaf', colors: ['#c2410c', '#ea580c', '#ca8a04', '#991b1b', '#a16207'] }],
  },
  black_friday: {
    label: 'Black Friday', mode: 'dark', icon: Tag, swatch: ['#000000', '#ef4444'],
    bg: '#050505', glow: 'radial-gradient(circle at 80% 40%, rgba(239,68,68,.35), transparent 55%), radial-gradient(circle at 10% 90%, rgba(250,204,21,.18), transparent 50%)',
    accent: '#f87171', decor: <IconDecor main={ShoppingBag} side={Tag} color="#f87171" glow="rgba(239,68,68,.5)" />,
    particles: [{ shape: 'confetti', colors: ['#ef4444', '#facc15', '#ffffff'] }],
  },
};
